import React from 'react';

const NegativeResult = () => {
	return (
		<div className="information">
			<p>
				Selon les renseignements que vous avez saisis, vous ne pouvez pas bénéficier de l'ASPA.
			</p>
		</div>
	);
};

export default NegativeResult;
